import React from "react";
import "./LoadingPopup.css"; // Create a CSS file for styling

interface LoadingProps {
  isLoading: Boolean;
  loadingText?: string;
}
const LoadingPopup = ({ isLoading, loadingText }: LoadingProps) => {
  if (!isLoading) return null;
  return (
    <div className="loading-popup">
      <div className="mb-5 flex flex-col space-y-[10px] w-44 h-44 flex-shrink-0 rounded-2xl bg-white shadow-sm content-center p-14">
        <img src={"/icons/loading.gif"} alt="Saving" />
        <div className="font-bold text-center text-gray-400">{loadingText ?? "Saving"}...</div>
      </div>
    </div>
  );
};

export default LoadingPopup;
